import aftersalesIcon from './images/退款.png'
import noticeIcom from './images/店铺公告.png'
import ordermanageIcon from './images/订单管理.png'
import orderPersonIcon from './images/配送人员管理.png'
import orderSetIcon from './images/店铺基础设置.png'
import refreshIcon from './images/刷新.png'

export default {
  noticeIcom: noticeIcom,
  orderSetIcon: orderSetIcon,
  refreshIcon: refreshIcon,
  ordermanageIcon: ordermanageIcon,
  aftersalesIcon: aftersalesIcon,
  orderPersonIcon: orderPersonIcon,
}
